import { DotNetType, createTypedField, Guid } from "tessa/platform";
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { CardRequest, CardService } from "tessa/cards/service";
import { CdRequestTypes } from "src/cdScripts/Helpers/CdRequestTypes";
import { CardUIExtension, ICardUIExtensionContext } from "tessa/ui/cards";
import { Card } from "tessa/cards";
import { showNotEmpty } from "tessa/ui";
import { isNullOrUndefined } from "util";
 
 

export class CdZosRvDocumentUIExtension extends CardUIExtension {

    private _disposer: Function | null = null;

    public async initialized(context: ICardUIExtensionContext) {
         
        let card: Card;
        if ((card = context.model.card) == null) {
            return;
        }

        if (!Guid.equals(card.typeId, CdCardTypes.PkZosRvDocumentypeID)) {
            return;
        }

        // Обработка при выборе объекта
        await this.HandleOnObjectChangedAsync(card);

        // Обработка при выборе договора
        await this.HandleOnContractChangedAsync(card);
    }


    /* Обработка при выборе объекта. */
    private async HandleOnObjectChangedAsync(card: Card) {

        let section = card.sections.tryGet('PkRdProperties');
        if (isNullOrUndefined(section)) {
            return;
        }
        section.fields.fieldChanged.add(async e => {
            if (e.fieldName === 'ObjectID') {
                let objectId = e.fieldValue;


                section!.fields.set("RegionID", null);
                section!.fields.set("RegionName", null);
                section!.fields.set("CityID", null);
                section!.fields.set("CityName", null);
                section!.fields.set("ProjectID", null);
                section!.fields.set("ProjectName", null);
                section!.fields.set("ObjectPlaceID", null);
                section!.fields.set("ObjectPlaceLivingComplex", null);

                if (isNullOrUndefined(objectId)) {
                    return
                }
                // Заполняем ЖК  
                const request = new CardRequest();
                request.requestType = CdRequestTypes.GetRdDivisionRoleProperties;
                request.info["FieldID"] = createTypedField(objectId, DotNetType.Guid);
                request.info["FieldRoleType"] = createTypedField(0, DotNetType.Int32);

                const response = await CardService.instance.request(request);

                await showNotEmpty(response.validationResult.build());
                if (!response.validationResult.isSuccessful) {
                    return;
                }
                section!.fields.set("RegionID", response.info.RegionID);
                section!.fields.set("RegionName", response.info.RegionName);
                section!.fields.set("CityID", response.info.CityID);
                section!.fields.set("CityName", response.info.CityName);
                section!.fields.set("ProjectID", response.info.ProjectID);
                section!.fields.set("ProjectName", response.info.ProjectName);
                section!.fields.set("ObjectPlaceID", response.info.ResidentialComplexID);
                section!.fields.set("ObjectPlaceLivingComplex", response.info.ResidentialComplexName);
            }
        });


    }
    /* Обработка при выборе договора. */
    private async HandleOnContractChangedAsync(card: Card) {

        let section = card.sections.tryGet('PkZosRvDocument');
        if (isNullOrUndefined(section)) {
            return;
        }
        section.fields.fieldChanged.add(async e => {
            if (e.fieldName === 'ContractID') {
                let contractID = e.fieldValue;

                section!.fields.set("ContractDate", null);

                if (isNullOrUndefined(contractID)) {
                    return
                }

                const request = new CardRequest();
                request.requestType = CdRequestTypes.ArDocumentIDPVirtualInfo;
                request.info["TypeFlag"] = createTypedField(0, DotNetType.Int32);
                request.info["ContractID"] = createTypedField(contractID, DotNetType.Guid);

                const response = await CardService.instance.request(request);

                await showNotEmpty(response.validationResult.build());
                if (!response.validationResult.isSuccessful) {
                    return;
                }
                section!.fields.set("ContractDate", response.info!.ContractDate);

            }
        });


    }

    public finalized() {
        // подчищаем за собой
        if (this._disposer) {
            this._disposer();
            this._disposer = null;
        }
    }
}